"use strict";
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const IValidation_1 = require("./IValidation");
const Yup = __importStar(require("yup"));
const helper_1 = require("./helper");
//todo validation based on filter type
exports.filterSchema = Yup.object()
  .shape({
    expression: Yup.string().required(),
    conditions: Yup.array()
      .of(
        Yup.object().shape({
          id: Yup.string().required(),
          key: Yup.string(),
          value: Yup.mixed().required(),
          operator: Yup.string(),
          type: Yup.mixed().required()
        })
      )
      .required()
  })
  .required();
class FilterNodeValidation {
  validate(node) {
    let data = node.getNodeData();
    let selectedResource = node.getSelectedResource();
    return helper_1.isValid(
      [
        { schema: exports.filterSchema, data },
        { schema: IValidation_1.nodeSchema, data: node.serializeNode() },
        { schema: IValidation_1.selectedResourceSchema, data: selectedResource }
      ],
      node.getNodeId()
    );
  }
}
exports.FilterNodeValidation = FilterNodeValidation;
//# sourceMappingURL=FilterNodeValidation.js.map
